import {Routes} from '@angular/router'
import {internetbankenResolver} from './application/route-resolver'

export default [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'neos',
    loadComponent: () => import('./neos/neos.component').then(m => m.NeosComponent)
  },
  {
    path: 'internetbanken',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
    resolve: [internetbankenResolver]
  },
  {
    path: '**',
    redirectTo: ''
  }
] satisfies Routes
